import { render, staticRenderFns } from "./PacketConnectionEditor.vue?vue&type=template&id=42c43089&scoped=true&"
import script from "./PacketConnectionEditor.vue?vue&type=script&lang=js&"
export * from "./PacketConnectionEditor.vue?vue&type=script&lang=js&"
import style0 from "./PacketConnectionEditor.vue?vue&type=style&index=0&id=42c43089&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c43089",
  null
  
)

export default component.exports